import { Box, Divider, IconButton, Modal, Stack, Typography } from "@mui/material";
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';



export default function ModalPopUp({ children, onClose, title, open, sx, titleSx }) {
    return (
        <Modal open={open} onClose={(_, reason) => {
            if (reason !== "backdropClick") {
                onClose();
            }
        }}>
            <Box
                sx={{
                  /*  position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    p: 1,
                    borderRadius: 1.5,
                    width: { xs: '90%', sm: '80%', md: '60%', lg: '50%' },
                    maxHeight: '90vh',
                    ...sx, */

                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    p: 0.7,
                    borderRadius: 1.5,
                    width: { xs: '90%', sm: '70%', md: '50%' },
                    maxHeight: '70vh',
                    display: 'flex',
                    flexDirection: 'column',
                    boxSizing: 'border-box',
                    flexGrow: 1,
                    ...sx
                }}
            >
                <Stack
                    direction='row'
                    alignItems='center'
                    justifyContent='space-between'
                    mb={1}
                    sx={{ bgcolor: '#20b2aa', height: 40, borderRadius: '8px' }}
                >
                    <Typography variant='h6' sx={{ color: '#fff', p: 1, ...titleSx }}>
                        {title}
                    </Typography>
                    <IconButton onClick={onClose} sx={{ p: 0, color: '#fff' }}>
                        <CloseIcon sx={{ width: '20px', height: '20px' }} />
                    </IconButton>
                </Stack>
                <Divider sx={{ mb: 2 }} />
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    // border: '2px solid black',
                    minHeight: 0
                }}>{children}</Box>
            </Box>
        </Modal>
    );
}

ModalPopUp.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    sx: PropTypes.object,
    titleSx: PropTypes.object,
};